// src/composables/useSortableTable.js
import { ref } from 'vue';
import axios from '@/services/axios';

export function useSortableTable(fetchUrl, initialSort = { key: '', order: 'asc' }) {
  const items       = ref([]);
  const totalPages  = ref(1);
  const totalItems = ref(0);
  const page        = ref(1);
  const limit       = ref(10);
  const currentSort = ref({ ...initialSort });
  const filters     = ref({});

  const sort = (col) => {
    if (currentSort.value.key === col) {
      currentSort.value.order = currentSort.value.order === 'asc' ? 'desc' : 'asc';
    } else {
      currentSort.value.key   = col;
      currentSort.value.order = 'asc';
    }
    load();
  };

  const arrow = (col) => {
    if (currentSort.value.key !== col) return '';
    return currentSort.value.order === 'asc' ? '▲' : '▼';
  };


async function load() {
  const params = {
    page:  page.value,
    limit: limit.value,
    sort:  currentSort.value.key || undefined,
    order: currentSort.value.order,
    ...filters.value
  };
  const res = await axios.get(fetchUrl, { params });

  items.value       = res.data.data;
  totalPages.value  = res.data.totalPages;
  totalItems.value = res.data.totalItems ?? res.data.total ?? 0
}

  const goPrev = () => { if (page.value>1) { page.value--; load(); } };
  const goNext = () => { if (page.value<totalPages.value) { page.value++; load(); } };

  return {
    items, totalPages, totalItems, page, limit,
    currentSort, filters,
    sort, arrow,
    load, goPrev, goNext
  };
}
